import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { OutOfScopeBlock } from '../blocks/OutOfScopeBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const OutOfScopesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { outOfScopes } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {outOfScopes.map((item, index) => (
        <OutOfScopeBlock key={index} outOfScope={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default OutOfScopesLayer
